export default {
  PAGE: 'page',
  FILTERS: 'filters[]',
  PRICE: 'price',
  ORDER_BY: 'order-by'
};
